import { Trans } from '@lingui/macro';

import StackedTokens from '@rover/icons/svg/stacked-tokens.svg';
import { Box, Flex, Paragraph, Text } from '@rover/kibble/core';

type Props = {
  petDescription: string;
  serviceUnit: string;
  priceRange: string;
  priceRangeAccessibilityLabel: string;
};

function PriceAnchoringCallout({
  petDescription,
  serviceUnit,
  priceRange,
  priceRangeAccessibilityLabel,
}: Props): JSX.Element {
  return (
    <Box p="4x" data-testid="price-anchoring-callout" webAs="section" webProps={{ tabIndex: 0 }}>
      <Flex flexDirection="row" alignItems="center" justifyContent="space-between" gap="4x">
        <Paragraph size="200" mb="0x" sx={{ flex: 1 }}>
          <Trans>
            Sitters with 4+ stars typically range from{' '}
            <Text
              fontWeight="semibold"
              textColor="success"
              aria-label={priceRangeAccessibilityLabel}
            >
              {priceRange}
            </Text>{' '}
            {serviceUnit} for a {petDescription} in this area.
          </Trans>
        </Paragraph>
        <Box flexShrink="0" width="90px" height="90px">
          <StackedTokens />
        </Box>
      </Flex>
    </Box>
  );
}

export default PriceAnchoringCallout;
